const location = {
  // 接口域名
  domain () {
    let URL = window.location.origin
    // URL = 'https://px.teacheredu.cn'
    return URL + '/'
  },
  // 静态资源域名
  static () {
    let URL = this.domain() + 'static/'
    return URL
  },
  // 三级页域名
  html () {
     let URL = this.domain() + 'html/'
    return URL
  },
  // 文件域名
  files () {
    let URL = this.domain() + 'files/'
    return URL
  }
}
export default location
